@if (teams().length === 0) {
	<div class="h-full flex justify-center align-center px-8 py-40">
		<span>No Active Standing Entries</span>
		{{ selectedClasses() }}
	</div>
} @else {
	<table class="timing-table table-auto w-full">
		<thead class="bg-surface-container text-on-surface-container text-xs sticky top-0">
			<tr>
				<th class="position-arrow-col"></th>
				<th class="text-left">P</th>
				<th class="text-left">#</th>
				<th class="text-left">Car</th>
				<th class="text-left">Team/Driver</th>
				<th class="text-right">Pic</th>
				<th class="text-right">Lap</th>
				@if (raceSessionService.gapByClass) {
					<th class="text-right">Gap</th>
					@if (enableMoreColumns()) {
						<th class="text-right">Class Gap</th>
						<th class="text-right">Interval</th>
					}
				} @else {
					<th class="text-right">Gap</th>
					@if (enableMoreColumns()) {
						<th class="text-right">Interval</th>
					}
				}
				<th>Last Lap</th>
				@if (enableMoreColumns()) {
					<th class="text-right">Best Lap</th>
					<th class="text-right">S1</th>
					<th class="text-right">S2</th>
					<th class="text-right">S3</th>
				}
			</tr>
		</thead>
		<tbody class="text-sm">
			<ng-container *ngFor="let team of teams(); trackBy: trackByFn">
				<tr
					class="hover:bg-surface-container-high"
					[class.team-row-moved-up]="positionChangeStateByNumber()[team?.number ?? ''] === 'up'"
					[class.team-row-moved-down]="positionChangeStateByNumber()[team?.number ?? ''] === 'down'"
					[ngClass]="timingTowerService.activeList().includes(team?.number) ? activeClass() : ''"
					[class.is-selected]="timingTowerService.activeList().includes(team?.number)"
					[style.background-color]="
						timingTowerService.activeList().includes(team?.number)
							? 'rgba(229, 57, 53, 0.14)'
							: null
					"
					[style.color]="
						timingTowerService.activeList().includes(team?.number)
							? 'var(--on-surface-container)'
							: null
					"
					[class.has-playback]="team?.playback?.url"
					(click)="toggleTeamSelection(team!)"
				>
					<td class="position-arrow-col">
						<vb-lxp-position-change-indicator
							[state]="positionChangeStateByNumber()[team?.number ?? ''] || 'neutral'"
						></vb-lxp-position-change-indicator>
					</td>
					<td>
						<span
							class="text-right timing-position-value"
							[ngClass]="
								timingTowerService.activeList().includes(team?.number) ? activeNumberClass() : ''
							"
							>{{ team?.activeStanding?.position }}</span
						>
					</td>
					<td>
						<div
							class="rounded-sm flex items-center justify-center"
							[title]="team?.class"
							[style.background-color]="team?.classDetails?.background"
							[style.color]="team?.classDetails?.foreground"
						>
							<span>{{ team?.number }}</span>
						</div>
					</td>
					<td>
						<img
							class="w-6 h-6 object-contain"
							[src]="team?.manufacturer || team?.vehicle || '' | teamLogoLookup: team?.class"
							alt="Logo"
							[title]="team?.manufacturer || team?.vehicle"
						/>
					</td>
					<td>
						<div class="team-driver-line">
							<span class="flex timing-driver-name">
								<span class="timing-driver-text">{{ team?.currentDriverFullName }}</span>
								@if (team?.playback?.url) {
									<i class="text-primary ml-1 mt-1 bi bi-play-circle timing-play-icon"></i>
								}
							</span>
						</div>
						<div style="font-size: 10px">
							<div>{{ team?.team }}</div>
						</div>
					</td>
					<td class="text-right">{{ team?.classStanding?.position }}</td>
					<td class="text-right">{{ team?.participantDetails?.currentLap }}</td>
					@if (raceSessionService.gapByClass) {
						<td class="timing-data-bold">
							@if (team?.activeStanding?.gapFirstLaps > 0) {
								{{ team?.activeStanding?.gapFirstLaps }}L
							} @else {
								+{{
									team?.activeStanding?.gapFirstTime
										? (team?.activeStanding?.gapFirstTime || 0 | timespanShort)
										: '0.000'
								}}
							}
						</td>
						@if (enableMoreColumns()) {
							<td class="timing-data-bold">
								@if (team?.classStanding?.gapFirstLaps > 0) {
									{{ team?.classStanding?.gapFirstLaps }}L
								} @else {
									+{{
										team?.classStanding?.gapFirstTime
											? (team?.classStanding?.gapFirstTime || 0 | timespanShort)
											: '0.000'
									}}
								}
							</td>
							<td class="timing-data-bold">
								@if (team?.activeStanding?.gapPreviousLaps > 0) {
									{{ team?.activeStanding?.gapPreviousLaps }}L
								} @else {
									+{{
										team?.activeStanding?.gapPreviousTime
											? (team?.activeStanding?.gapPreviousTime || 0 | timespanShort)
											: '0.000'
									}}
								}
							</td>
						}
					} @else {
						<td class="timing-data-bold">
							@if (team?.activeStanding?.gapFirstLaps > 0) {
								{{ team?.activeStanding?.gapFirstLaps }}L
							} @else {
								+{{
									team?.activeStanding?.gapFirstTime
										? (team?.activeStanding?.gapFirstTime || 0 | timespanShort)
										: '0.000'
								}}
							}
						</td>
						@if (enableMoreColumns()) {
							<td class="timing-data-bold">
								@if (team?.activeStanding?.gapPreviousLaps > 0) {
									{{ team?.activeStanding?.gapPreviousLaps }}L
								} @else {
									+{{
										team?.activeStanding?.gapPreviousTime
											? (team?.activeStanding?.gapPreviousTime || 0 | timespanShort)
											: '0.000'
									}}
								}
							</td>
						}
					}
					<td class="timing-data-bold timing-last-lap">
						@if (team?.participantDetails?.lastLap?.time) {
							<span [ngClass]="team?.lastLapClass">
								{{ team?.participantDetails?.lastLap?.time | timespanMs }}
							</span>
						} @else {
							<span>--</span>
						}
					</td>
					@if (enableMoreColumns()) {
						<td class="timing-data-bold">
							@if (team?.participantDetails?.bestLap?.time) {
								<span>{{ team?.participantDetails?.bestLap?.time | timespanMs }}</span>
							} @else {
								<span>--</span>
							}
						</td>
						<td class="timing-data-bold">
							@if (team?.currentLapSectorData[1]) {
								<span [ngClass]="team?.currentLapSectorData[1].className">
									{{ team?.currentLapSectorData[1].time | timespanShort }}
								</span>
							} @else {
								<span>--</span>
							}
						</td>
						<td class="timing-data-bold">
							@if (team?.currentLapSectorData[2]) {
								<span [ngClass]="team?.currentLapSectorData[2].className">
									{{ team?.currentLapSectorData[2].time | timespanShort }}
								</span>
							} @else {
								<span>--</span>
							}
						</td>
						<td class="timing-data-bold">
							@if (team?.currentLapSectorData[3]) {
								<span [ngClass]="team?.currentLapSectorData[3].className">
									{{ team?.currentLapSectorData[3].time | timespanShort }}
								</span>
							} @else {
								<span>--</span>
							}
						</td>
					}
				</tr>
			</ng-container>
		</tbody>
	</table>
}
